import React, { useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface LongContentWrapperProps {
  className?: string;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
  children: React.ReactNode;
  lineHeight?: number;
}

const LongContentWrapper: React.FC<LongContentWrapperProps> = ({
  className = "",
  tooltipPlacement = "bottom",
  children,
  lineHeight,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = () => {
    const el = contentRef.current;
    if (el) {
      setIsOverflowing(
        el.scrollWidth > el.clientWidth ||
          !!(lineHeight && el.scrollHeight > el.clientHeight),
      );
    }
  };

  const classNames = cn(
    `truncate max-w-full`,
    lineHeight && `overflow-y-hidden h-${lineHeight} max-h-${lineHeight}`,
    className,
  );

  return (
    <TooltipProvider>
      {isOverflowing ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <div
              ref={contentRef}
              onMouseEnter={checkOverflow}
              className={classNames}
            >
              {children}
            </div>
          </TooltipTrigger>
          <TooltipContent
            className="flex flex-col gap-1 border border-accent-foreground"
            side={tooltipPlacement}
          >
            {children}
          </TooltipContent>
        </Tooltip>
      ) : (
        <div
          ref={contentRef}
          onMouseEnter={checkOverflow}
          className={classNames}
        >
          {children}
        </div>
      )}
    </TooltipProvider>
  );
};

export default LongContentWrapper;
